const TurboLoader = {

	init: function () {

		// we don't use animated progress
		Turbolinks.ProgressBar.prototype.refresh = function() {}
		// custom css
		Turbolinks.ProgressBar.defaultCSS = "";

		// creates progress bar with custom markup
		Turbolinks.ProgressBar.prototype.installProgressElement = function() {
			return $('body').before($('<div class="overlay"><div class="soft_overlay"></div><div class="loader">Loading...</div></div>'));
		};

		// removes progress bar with custom markup
		Turbolinks.ProgressBar.prototype.uninstallProgressElement = function() {
			$(document).find('.overlay').remove();
		};

		// changes the default 500ms threshold to show progress bar
		Turbolinks.BrowserAdapter.prototype.showProgressBarAfterDelay = function() {
			return this.progressBarTimeout = setTimeout(this.showProgressBar, 50);
		};

	}

};

export default TurboLoader;
